import React, { useEffect, useState } from 'react';
import Styles from './SubscriptionItem.module.scss';
import localization from '../../../data/localization/en-US.json';

const SubscriptionItem = (props) => {
  const {
    item,
    isEditing,
    globallySuppressed,
    unsubscribeAllCheckbox,
    updateSubscribeList,
    updateUnsubscribeList,
  } = props;

  const { suppressed } = item;
  const [isChecked, setChecked] = useState(!suppressed);

  // This method is to create camel cased id's out of subscription names
  const camelCase = (name) => {
    let camelCased = '';
    if (name) {
      camelCased = name.replace(' ', '');
      camelCased = camelCased.replace(camelCased.charAt(0), camelCased.charAt(0).toLowerCase());
    }
    return camelCased;
  };

  const updateSubcriptionList = (id, value) => {
    if (value === true) {
      updateSubscribeList(id);
    } else if (value === false) {
      updateUnsubscribeList(id);
    }
  };

  useEffect(() => {
    setChecked(!suppressed);
  }, [item]);

  return (
    <>
      {item && (
        <div className={Styles.itemContainer}>
          <div className={Styles.subscriptionItem}>
            {isEditing
              && (
                <input
                  id={camelCase(item.name)}
                  type='checkbox'
                  disabled={unsubscribeAllCheckbox}
                  checked={isChecked && !unsubscribeAllCheckbox}
                  onChange={(e) => {
                    if (!unsubscribeAllCheckbox) {
                      setChecked(e.target.checked);
                      updateSubcriptionList(item.id, e.target.checked);
                    }
                  }}
                />
              )
            }
            <label
              className={`${Styles.subscriptionLabel} ${isEditing && (!isChecked || globallySuppressed) ? Styles.unsubscribed : null}`}
              forhtml={camelCase(item.name)}
              onClick={() => {
                if (isEditing) {
                  setChecked(!isChecked);
                  updateSubcriptionList(item.id, !isChecked);
                }
              }}
            >
              {item.name}
            </label>
          </div>
          {!isEditing
            && (
              <div>
                <span className={Styles.subscriptionStatus}>
                  {(item.suppressed || globallySuppressed)
                    ? localization.unsubscribed : localization.subscribed}
                </span>
              </div>
            )
          }
        </div>
      )}
    </>
  );
};

export default SubscriptionItem;
